export default {
  path: '/store',
  meta: {
    title: '商家中心',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/store`),
}



// WEBPACK FOOTER //
// ./src/views/Store/router.js